import React, { Component } from "react";

class CircularHeaderLoader extends Component {
  static defaultProps = {
    radius: 44,
    stroke: 6,
    progress: 0,
    expected_progress: 0,
    id: "",
  };
  handler = undefined;

  constructor(props) {
    super(props);
    const { radius, stroke } = props;
    // Adjust radius to account for stroke width so the circle fills the container
    this.normalizedRadius = radius - stroke / 2;
    this.circumference = this.normalizedRadius * 2 * Math.PI;
    this.state = {
      progressDashOffset: this.circumference,
      expectedProgressDashOffset: this.circumference,
    };
  }

  calcStrokeDashoffset(p) {
    return this.circumference - (p / 100) * this.circumference;
  }

  componentDidMount() {
    const { progress, expected_progress } = this.props;
    const progressStrokeDashoffset = this.calcStrokeDashoffset(progress);
    const expectedProgressStrokeDashoffset = this.calcStrokeDashoffset(
      expected_progress,
    );

    this.handler = setTimeout(() => {
      this.setState({
        progressDashOffset: progressStrokeDashoffset,
        expectedProgressDashOffset: expectedProgressStrokeDashoffset,
      });
    }, 300);
  }

  componentWillUnmount() {
    clearTimeout(this.handler);
  }

  render() {
    const {
      radius,
      stroke,
      children,
      campaign,
      progress,
      expected_progress,
      id,
    } = this.props;
    

    return (
      <div
        className="gl-progress-ring-container"
        style={{ height: radius * 2, width: radius * 2 }}
      >
        <svg className="gl-progress-ring" height="100%" width="100%">
          <defs>
            <filter id={`ring-shadow-${id}`} x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow className="gl-progress-ring__shadow" dx="0" dy="0" stdDeviation="8" />
            </filter>
          </defs>
          <circle
            className="gl-progress-ring__container"
            fill="white"
            strokeWidth={stroke}
            r={this.normalizedRadius - 4}
            cx={radius}
            cy={radius}
            filter={`url(#ring-shadow-${id})`}
          />

          <circle
            id={`prog-${id}`}
            stroke={
              campaign.template &&
              campaign.template.appearence &&
              campaign.template.appearence.colors &&
              campaign.template.appearence.colors["brand-default"]
            }
            zindex={progress <= expected_progress ? 100 : 50}
            className="gl-progress-ring__loader"
            strokeLinecap="round"
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={this.circumference + " " + this.circumference}
            style={{ strokeDashoffset: this.state.progressDashOffset }}
            r={this.normalizedRadius}
            cx={radius}
            cy={radius}
          />

          <circle
            id={`exp-prog-${id}`}
            stroke={
              campaign.template &&
              campaign.template.appearence &&
              campaign.template.appearence.colors &&
              campaign.template.appearence.colors["brand-hover"]
            }
            zindex={expected_progress <= progress ? 100 : 50}
            className="gl-progress-ring__loader"
            strokeLinecap="round"
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={this.circumference + " " + this.circumference}
            style={{ strokeDashoffset: this.state.expectedProgressDashOffset }}
            r={this.normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>

        <div className="gl-progress-text">{children}</div>
      </div>
    );
  }
}

export default CircularHeaderLoader;
